import DestinationLink from './destination-link';

export default DestinationLink;
